import React from "react";
import "./FeedbackModal.css"; // スタイルを適用するための CSS（別途作成）

const FeedbackModal = ({ comment, setComment, onSubmit, onClose }) => {
  return (
    <div className="modal">
      <div className="modal-content">
        <h2>フィードバックの送信</h2>
        <p>{"コメントの入力をお願いします。\n今後の開発の参考といたします。"}</p>
        <textarea
          className="comment-area"
          rows="5"
          cols="50"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="コメントを入力してください..."
        />
        <div className="modal-buttons">
          <button className="blue-button" onClick={onSubmit}>送信</button>
          <button className="red-button"onClick={onClose}>キャンセル</button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
